import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSmile } = FiIcons;

export default function Logo({ className = "w-10 h-10", showText = false, textClassName = "text-xl" }) {
  return (
    <div className="flex items-center gap-2">
      <div className={`bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-indigo-100 ${className}`}>
        <SafeIcon icon={FiSmile} className="w-1/2 h-1/2" />
      </div>
      {showText && (
        <span className={`font-black tracking-tighter text-slate-900 ${textClassName}`}>
          Psico<span className="text-indigo-600">App</span>
        </span>
      )}
    </div>
  );
}